import { useQuery, useQueryClient } from '@tanstack/react-query';
import ChannelSearchMetaService from '../../services/channel-search-meta';

export const useChannelSearchMeta = (channelId: string) => {
  const queryClient = useQueryClient();

  return useQuery(
    ['channelSearchMeta', channelId],
    async () => {
      const service = new ChannelSearchMetaService(channelId);
      const response = await service.fetch();
      return response.data;
    },
    {
      enabled: !!channelId,
      initialData: () => {
        return queryClient.getQueryData<{
          categories: [];
        }>(['channelSearchMeta', channelId]);
      },
    }
  );
};
